import { useTranslation } from 'react-i18next';

export function ActivityTimeDiffDisplay({ timeDiff }: { timeDiff: { key: string; count?: number } }) {
  const { t } = useTranslation();

  return <span>{timeDiff.count ? t(timeDiff.key, { count: timeDiff.count }) : t(timeDiff.key)}</span>;
}
